import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';

import { type Evento } from '@/interfaces/model/eventos.interface';
import type { CustomColumnDef } from '@ctn/ui/types/ctn-table';

type getColumnsParams = {
	disabled?: {
		detalle?: boolean;
	};
};

const getColumns = (params?: getColumnsParams) => {
	const columns: Array<CustomColumnDef<Evento>> = [
		{
			accessorKey: 'fechaCreacion',
			header: 'Fecha y hora',
			th: {
				width: 164,
			},
			enableSorting: false,
			responsive: {
				sizeColumn: 'full',
			},
			cell({ getValue }) {
				return <CTNEllipsis content={getValue() as string} />;
			},
		},
		{
			accessorKey: 'tipoEvento',
			header: 'Evento',
			enableSorting: false,
			th: {
				width: 264,
			},
			responsive: {
				sizeColumn: 'full',
			},
			cell({ getValue }) {
				const value = getValue() as Evento['tipoEvento'];
				return <CTNEllipsis content={value.descripcion} />;
			},
		},
	];

	if (!params?.disabled?.detalle) {
		columns.push({
			accessorKey: 'detalle',
			header: 'Descripción',
			enableSorting: false,
			responsive: {
				sizeColumn: 'full',
			},
			cell({ getValue }) {
				return <CTNEllipsis content={getValue() as string} />;
			},
		});
	}

	return columns;
};

export { getColumns };
